/* AUSVÉ — main.js */

(function () {
  'use strict';

  /* ---------- Image fallback ----------
     If any <img> fails to load, swap it for a luxury-themed inline SVG
     so we never show a broken-image icon. */
  const fallbackSvg =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 1000" preserveAspectRatio="xMidYMid slice">' +
        '<defs>' +
          '<linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
            '<stop offset="0%" stop-color="#ece5d8"/>' +
            '<stop offset="55%" stop-color="#d8c79e"/>' +
            '<stop offset="100%" stop-color="#a8884f"/>' +
          '</linearGradient>' +
        '</defs>' +
        '<rect width="800" height="1000" fill="url(#g)"/>' +
        '<g fill="none" stroke="#fbf8f3" stroke-width="1.2" opacity=".85">' +
          '<circle cx="400" cy="470" r="120"/>' +
          '<circle cx="400" cy="470" r="80"/>' +
          '<path d="M340 470 L400 410 L460 470 L400 530 Z"/>' +
        '</g>' +
        '<text x="400" y="700" text-anchor="middle" font-family="Georgia, serif" font-style="italic" font-size="36" fill="#fbf8f3" letter-spacing="6">AUSVÉ</text>' +
      '</svg>'
    );

  function bindImageFallback(img) {
    if (img.dataset.fallbackBound) return;
    img.dataset.fallbackBound = '1';
    img.addEventListener('error', function handleErr() {
      if (img.src === fallbackSvg) return;
      img.removeEventListener('error', handleErr);
      img.src = fallbackSvg;
      img.style.objectFit = 'cover';
    });
    if (img.complete && img.naturalWidth === 0 && img.src) {
      img.dispatchEvent(new Event('error'));
    }
  }

  document.querySelectorAll('img').forEach(bindImageFallback);

  /* Bind to images added later (e.g. swapped via gallery) */
  const mo = new MutationObserver((records) => {
    records.forEach(r => r.addedNodes.forEach(n => {
      if (n.nodeType !== 1) return;
      if (n.tagName === 'IMG') bindImageFallback(n);
      n.querySelectorAll && n.querySelectorAll('img').forEach(bindImageFallback);
    }));
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Mobile menu ---------- */
  const hamburger = document.querySelector('.hamburger');
  const body = document.body;
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      body.classList.toggle('menu-open');
      const expanded = body.classList.contains('menu-open');
      hamburger.setAttribute('aria-expanded', expanded);
    });
    document.querySelectorAll('.mobile-drawer a').forEach(a => {
      a.addEventListener('click', () => body.classList.remove('menu-open'));
    });
  }

  /* ---------- Sticky header shadow ---------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal on scroll ---------- */
  document.documentElement.classList.add('js-reveal');
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    reveals.forEach((el) => io.observe(el));
    // Safety: anything still hidden after 2s gets revealed (e.g. tiny elements that never cross threshold)
    setTimeout(() => reveals.forEach(el => el.classList.add('in')), 2000);
  } else {
    reveals.forEach((el) => el.classList.add('in'));
  }

  /* ---------- Product tabs (homepage) ---------- */
  document.querySelectorAll('[data-tabs]').forEach(group => {
    const tabs = group.querySelectorAll('.tab');
    const targetId = group.getAttribute('data-target');
    const target = targetId ? document.getElementById(targetId) : null;
    tabs.forEach(t => {
      t.addEventListener('click', () => {
        tabs.forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        if (target) {
          const filter = t.dataset.filter;
          target.querySelectorAll('.product').forEach(p => {
            const match = !filter || filter === 'all' || (p.dataset.cat || '').includes(filter);
            p.style.display = match ? '' : 'none';
          });
        }
      });
    });
  });

  /* ---------- Gender tabs (Shop) ---------- */
  document.querySelectorAll('[data-gender-tabs]').forEach(group => {
    const tabs = group.querySelectorAll('.g-tab');
    const targetId = group.getAttribute('data-target');
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    const countEl = document.querySelector('[data-result-count]');
    const total = target.querySelectorAll('.product').length;

    tabs.forEach(t => {
      t.addEventListener('click', () => {
        tabs.forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const want = t.dataset.gender;
        let shown = 0;
        target.querySelectorAll('.product').forEach(p => {
          const tags = (p.dataset.gender || '').split(/\s+/);
          const match = want === 'all' || tags.includes(want);
          p.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (countEl) countEl.textContent = `Showing 1 — ${shown} of ${total}`;
      });
    });
  });

  /* ---------- Product gallery ---------- */
  const galMain = document.querySelector('[data-gallery-main]');
  if (galMain) {
    const mainWrap = galMain.closest('.gallery-main');
    const gallery = galMain.closest('.gallery');

    document.querySelectorAll('[data-gallery-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        document.querySelectorAll('[data-gallery-thumb]').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        galMain.src = t.dataset.src || t.src;
      });
    });

    /* Hover zoom — desktop visibility is gated in CSS (needs room beside the image) */
    if (mainWrap && gallery) {
      const ZOOM = 2.2;
      const lens = document.createElement('div');
      lens.className = 'zoom-lens';
      mainWrap.appendChild(lens);
      const result = document.createElement('div');
      result.className = 'zoom-result';
      gallery.appendChild(result);

      const refreshBg = () => {
        result.style.backgroundImage = `url("${galMain.currentSrc || galMain.src}")`;
      };

      mainWrap.addEventListener('mousemove', e => {
        const rect = mainWrap.getBoundingClientRect();
        const nw = galMain.naturalWidth;
        const nh = galMain.naturalHeight;
        if (!nw || !nh) return;

        /* Match the main image's object-fit: cover so the zoom isn't stretched */
        const scale = Math.max(rect.width / nw, rect.height / nh);
        const dispW = nw * scale;
        const dispH = nh * scale;
        const offX = (dispW - rect.width) / 2;
        const offY = (dispH - rect.height) / 2;

        const lw = rect.width / ZOOM;
        const lh = rect.height / ZOOM;

        result.style.width = rect.width + 'px';
        result.style.height = rect.height + 'px';
        result.style.backgroundSize = (dispW * ZOOM) + 'px ' + (dispH * ZOOM) + 'px';
        lens.style.width = lw + 'px';
        lens.style.height = lh + 'px';

        let x = e.clientX - rect.left - lw / 2;
        let y = e.clientY - rect.top - lh / 2;
        x = Math.max(0, Math.min(x, rect.width - lw));
        y = Math.max(0, Math.min(y, rect.height - lh));

        lens.style.left = x + 'px';
        lens.style.top = y + 'px';
        result.style.backgroundPosition = `-${(x + offX) * ZOOM}px -${(y + offY) * ZOOM}px`;
      });
      mainWrap.addEventListener('mouseenter', () => { refreshBg(); mainWrap.classList.add('zooming'); });
      mainWrap.addEventListener('mouseleave', () => mainWrap.classList.remove('zooming'));
    }
  }

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll('[data-qty]').forEach(box => {
    const input = box.querySelector('input');
    box.querySelector('[data-qty-dec]').addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    box.querySelector('[data-qty-inc]').addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- Swatch toggles ---------- */
  document.querySelectorAll('[data-swatch-group]').forEach(group => {
    group.querySelectorAll('.swatch').forEach(sw => {
      sw.addEventListener('click', () => {
        group.querySelectorAll('.swatch').forEach(x => x.classList.remove('active'));
        sw.classList.add('active');
      });
    });
  });

  /* ---------- Newsletter (front-end only) ---------- */
  const newsletter = document.querySelector('.newsletter form');
  if (newsletter) {
    newsletter.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = newsletter.querySelector('input');
      if (input && input.value) {
        newsletter.innerHTML = '<p style="color:#c9a96a;letter-spacing:.18em;text-transform:uppercase;font-size:12px;padding:18px 0;">Thank you. Your invitation is on its way.</p>';
      }
    });
  }

  /* ---------- Contact form (front-end only) ---------- */
  const contactForm = document.querySelector('[data-contact-form]');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const status = contactForm.querySelector('[data-form-status]');
      if (status) {
        status.textContent = 'Thank you. We will respond within 24 hours.';
        status.style.color = '#a8884f';
      }
      contactForm.reset();
    });
  }

})();
